import { Component, ViewChild, ElementRef  } from '@angular/core';
import { NavController,NavParams,AlertController,ViewController,App,LoadingController, Loading} from 'ionic-angular';

import { ListPage } from '../../pages/list/list';
import { AuthService } from '../../providers/auth';

import { RidePage } from '../../pages/ride/ride';


declare var google;

@Component({
  selector: 'page-detail',
  templateUrl: 'detail.html'
})
export class DetailPage {
  loading: Loading;
  startbtn: boolean = true;
  drivestartbtn:boolean=true;
  dropbtn:boolean=true;
  tab1Root: any = ListPage;
  tab2Root: any = ListPage;
  pet:any;
  
  selectedItem: any;
  obj:any;
  obj2:any;
  obj3:any;
  items;
  items2;
  items3;
 
routeResponse;
 //  @ViewChild(Tabs) tabs;
 

  constructor(public loadingCtrl: LoadingController,private alertCtrl: AlertController,public navCtrl: NavController,public authService:AuthService,public navParams: NavParams) {
    
    this.items = navParams.get('data');
  
  }



  

  
  ionViewDidLoad() {

  
    console.log(this.items);


}
 


    
}



// WEBPACK FOOTER //
// ./src/pages/detail/detail.ts